import "core-js/modules/es.function.name.js";
import React from 'react';
import { useTranslation } from 'react-i18next';
import { getSelectedAndTodayDate } from 'utils/timezone';
import getBasicDate from 'utils/dates/getBasicDate';
import FormField, { DefaultFormFieldLayout } from 'components/FormField';
import { TimeZoneField } from 'components/FormFields';
import RadioButtonOption from 'components/RadioButtonOption';
import ShadedCard from 'components/ShadedCard';
import Stack from 'components/Stack';
import FormStack from 'components/FormStack';
import DatePicker from 'components/DatePicker';
import TimePicker from 'components/TimePicker';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export default function UnlockingOptionsPanel(_ref) {
  var _unlockTimezone$value;
  var fields = _ref.fields;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var isLocked = fields.isLocked,
    lockingMode = fields.lockingMode,
    unlockDate = fields.unlockDate,
    unlockTime = fields.unlockTime,
    unlockTimezone = fields.unlockTimezone;
  var _getSelectedAndTodayD = getSelectedAndTodayDate(unlockDate.value, unlockTimezone.value),
    zonedUnlockDate = _getSelectedAndTodayD.selectedDate,
    zonedTodayDate = _getSelectedAndTodayD.zonedTodayDate;
  return /*#__PURE__*/_jsxs(ShadedCard, {
    borderRadius: "small",
    px: "m",
    py: "s",
    mt: "s",
    ml: "xl",
    children: [/*#__PURE__*/_jsx(FormField, {
      as: "fieldset",
      label: t('section_unlocking_options'),
      children: /*#__PURE__*/_jsxs(Stack, {
        spacing: "xs",
        mt: "xxs",
        children: [/*#__PURE__*/_jsx(RadioButtonOption, {
          bold: true,
          name: "section_unlocking_mode",
          label: t('section_unlocking_manual'),
          description: t('section_unlocking_manual_info'),
          descriptionType: "subtitle",
          checked: isLocked.value && lockingMode.value === null || lockingMode.value === 'locked',
          onChange: function onChange() {
            return lockingMode.set('locked');
          }
        }), /*#__PURE__*/_jsx(RadioButtonOption, {
          bold: true,
          name: "section_unlocking_mode",
          label: t('section_unlocking_progress'),
          description: t('section_unlocking_progress_info'),
          descriptionType: "subtitle",
          checked: lockingMode.value === 'progress',
          onChange: function onChange() {
            return lockingMode.set('progress');
          }
        }), /*#__PURE__*/_jsx(RadioButtonOption, {
          bold: true,
          name: "section_unlocking_mode",
          label: t('section_unlocking_time'),
          description: t('section_unlocking_time_info'),
          descriptionType: "subtitle",
          checked: lockingMode.value === 'time',
          onChange: function onChange() {
            return lockingMode.set('time');
          }
        })]
      })
    }), lockingMode.value === 'time' && /*#__PURE__*/_jsx(DefaultFormFieldLayout, {
      horizontal: true,
      horizontalLabelWidth: 125,
      children: /*#__PURE__*/_jsxs(FormStack, {
        spacing: "xs",
        mt: "xs",
        ml: 30,
        children: [/*#__PURE__*/_jsx(FormField, {
          required: true,
          label: "".concat(t('property_date'), " *"),
          alert: unlockDate.error,
          children: /*#__PURE__*/_jsx(DatePicker, {
            dateFormat: "dd/MM/yyyy",
            selected: zonedUnlockDate,
            minDate: zonedTodayDate,
            onChange: function onChange(setDate) {
              if (setDate) {
                var scheduledDate = getBasicDate(setDate);
                unlockDate.set(scheduledDate);
              }
            }
          })
        }), /*#__PURE__*/_jsx(FormField, {
          as: "span",
          label: t('property_time'),
          labelId: "unlock-time-label",
          children: /*#__PURE__*/_jsx(TimePicker, {
            labelledById: "unlock-time-label",
            onChange: function onChange(newValue) {
              return unlockTime.set(newValue);
            },
            value: unlockTime.value
          })
        }), /*#__PURE__*/_jsx(TimeZoneField, {
          value: (_unlockTimezone$value = unlockTimezone.value) !== null && _unlockTimezone$value !== void 0 ? _unlockTimezone$value : undefined,
          onChange: function onChange(selectedTimezone) {
            unlockTimezone.set(selectedTimezone.name);
          },
          alert: unlockTimezone.error
        })]
      })
    })]
  });
}